export type ImageTypesProps = {
  image_max: number
  video_max: number
  gif_max: number
}

type ImageValidationProps = {
  [key: string]: ImageTypesProps
}

const imageValidations: ImageValidationProps = {
  twitter_thread_tweet: {
    image_max: 4,
    video_max: 0,
    gif_max: 0,
  },
  twitter_thread_video: {
    image_max: 0,
    video_max: 1,
    gif_max: 0,
  },
  twitter_thread_gif: {
    image_max: 0,
    video_max: 0,
    gif_max: 1,
  },
}

const validations = {
  imageValidations,
}

export { validations }
